export default {
      id: "game-on-usage",
      viewBox: "0 0 133.12 130.6",
      url: __webpack_public_path__ + "img/icons.b8e1d04b.svg#game-on",
      toString: function () {
        return this.url;
      }
    }